import {NgModule} from '@angular/core';
import { TermsOfServiceComponent } from './web/terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './web/privacy-policy/privacy-policy.component';
import { WebLandingComponent } from './web/weblanding/weblanding.component';
import { MaterialModule } from './shared/material.module';
import { YoutubeDialogComponent } from './web/youtube-dialog/youtube-dialog.component';
import { SharedModule } from './shared/shared.module';
import { FooterComponent } from './web/footer/footer.component';
import { WebnavComponent } from './web/webnav/webnav.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { RouterModule } from '@angular/router';
import { FullsizeDragdropComponent } from './web/fullsize-dragdrop/fullsize-dragdrop.component';
import { WeblibraryComponent } from './web/weblibrary/weblibrary.component';
import { WeblibraryNewAiSearchComponent } from './web/weblibrary-new-ai-search/weblibrary-new-ai-search.component';
import { WebEditCollectionComponent } from './web/webedit-collection/webedit-collection.component';
import { WebPortfolioComponent } from './web/webportfolio/webportfolio.component';
import { WebuploadsandboxComponent } from './web/webuploadsandbox/webuploadsandbox.component';
import { WebpanelComponent } from './web/webpanel/webpanel.component';
import { WebpopupdialogComponent } from './web/webpopupdialog/webpopupdialog.component';
import { WebModelsCardComponent } from './web/web-models-card/web-models-card.component';
import { WebCollectionDetailsComponent } from './web/web-collection-details/web-collection-details.component';
import { WebaddfromComponent } from './web/webaddfrom/webaddfrom.component';
import { WebHomeComponent } from './web/webhome/webhome.component';
import { TweakerstyleComponent } from './web/tweakerstyle/tweakerstyle.component';
import { NgxStripeModule } from 'ngx-stripe';
import { WebstripepaymentComponent } from './web/webstripepayment/webstripepayment.component';
import { WebsubscriptionComponent } from './web/websubscription/websubscription.component';
import { environment } from 'src/environments/environment';
import { WebaccountComponent } from './web/webaccount/webaccount.component';
import { WebrenderlimitComponent } from './web/webrenderlimit/webrenderlimit.component';
import { WebSharedUserContentComponent } from './web/web-shared-user-content/web-shared-user-content.component';
import { WebStoreComponent } from './web/web-store/web-store.component';
import { WebReviewComponent } from './web/web-review/web-review.component';
import { MissingTexturesSyncComponent } from './shared/components/upload-missing-textures/missing-textures-sync.component';
import { WebRootComponent } from './web/web-root/web-root.component';
import { BrowserFingerprintService } from './shared/services/browser-fingerprint.service';
import { DeviceDetectionService } from './shared/services/device-detection.service';
import { VideoAnalyticsService } from './shared/services/video-analytics.service';
import { WebPublishBulkComponent } from './web/web-publishbulk/web-publishbulk.component';
import { ExtendedStoreComponent } from './web/extended-store/extended-store.component';
import { AdvancedSearchNavbarComponent } from './web/advanced-search-navbar/advanced-search-navbar.component';
import { AdvancedSearchThumbCardComponent } from './web/advanced-search-thumb-card/advanced-search-thumb-card.component';
import { WebAdvancedSearchDevComponent } from './web/web-advanced-search-dev/web-advanced-search-dev.component';
import { DiscoverLandingComponent } from './web/discover-landing/discover-landing.component';
import { ReferenceRequestDialogComponent } from './web/discover-landing/reference-request-dialog/reference-request-dialog.component';
import { RenderModule } from './web/render/render.module';



@NgModule({
  declarations: [
    WebRootComponent,
    WebLandingComponent,
    WebHomeComponent,
    WebuploadsandboxComponent,
    WebEditCollectionComponent,
    WebPortfolioComponent,
    TermsOfServiceComponent,
    PrivacyPolicyComponent,
    YoutubeDialogComponent,
    FooterComponent,
    WebnavComponent,
    FullsizeDragdropComponent,
    WeblibraryComponent,
    WeblibraryNewAiSearchComponent,
    WebpanelComponent,
    WebpopupdialogComponent,
    WebModelsCardComponent,
    WebCollectionDetailsComponent,
    WebaddfromComponent,
    TweakerstyleComponent,
    WebstripepaymentComponent,
    WebsubscriptionComponent,
    WebaccountComponent,
    WebrenderlimitComponent,
    WebSharedUserContentComponent,
    WebStoreComponent,
    WebReviewComponent,
    MissingTexturesSyncComponent,
    WebPublishBulkComponent,
    ExtendedStoreComponent,
    AdvancedSearchNavbarComponent,
    AdvancedSearchThumbCardComponent,
    WebAdvancedSearchDevComponent,
    DiscoverLandingComponent,
    ReferenceRequestDialogComponent
  ],
  imports: [
    MaterialModule,
    SharedModule,
    RouterModule,
    NgxFileDropModule,
    NgxStripeModule.forRoot(environment.stripeKey),
    RenderModule,

  ],
  exports: [
    NgxFileDropModule
  ],
  providers: [
    BrowserFingerprintService,
    DeviceDetectionService,
    VideoAnalyticsService
  ]
})
export class WebModule {}
